import { render, staticRenderFns } from "./email.component.vue?vue&type=template&id=97edd27e"
import script from "./email.component.vue?vue&type=script&lang=js"
export * from "./email.component.vue?vue&type=script&lang=js"
import style0 from "./email.component.vue?vue&type=style&index=0&id=97edd27e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports